import { View } from './View';
/**
 * An abstract visual Calendar
 */
export class Calendar extends View {
}
